import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../core/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  user: any = {}
  password;
  sidebarList: any = {}
  show = false;
  constructor(private router: Router, private _adminService: ApiService, private toastr: ToastrService) { }
  ngOnInit(): void {
    this.password = 'password';
  }
  onClick() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }
  async login() {
    let url = "users/login"
    this._adminService.login(url, this.user).subscribe((response) => {
      if (response.success == true) {
        window.localStorage.setItem('m_ind_token', response.data.token);
        window.localStorage.setItem('m_ind_name', response.data.name);
        let type = response.data.type == '1' ? 'user' : (response.data.type == '2') ? 'plantadmin' : (response.data.type == '3') ? 'orgadmin' : (response.data.type == '4') ? 'plantsadmin' : response.data.type;
        window.localStorage.setItem('m_ind_type', type);
        this.toastr.success(' Success', 'Log In Successfully');
        this.router.navigate(['home']);
        // this.getSideBar()
      } else {
        this.toastr.error('Error!', response.message);
      }
    })
    /*this._adminService.login(this.user,url).then(response => {
      if(response.success==true){  
        window.localStorage.setItem('token',response.data.token);
        window.localStorage.setItem('name',response.data.name);
        this.toastr.success(' Success', 'LoggedIn Successfully');
        if(window.localStorage.getItem('token')){
          this.router.navigate(['events']);
        } 
        
        
      }else{
        this.toastr.error('Error!', response.message);  
      }
    })
    //this.router.navigateByUrl('home');*/
  }
  getSideBar() {
    let url = "org/limit/details";
    let data = {};
    this._adminService.post(url, data).subscribe((response) => {
      if (response.status == 200) {
        if (response.data[0] != undefined || response.data[0] != null) {
          this.sidebarList.issue = response.data[0].issue_selected;
          this.sidebarList.issue2 = response.data[0].observation2_selected;
          this.sidebarList.checklist = response.data[0].checklist_selected;
          this.sidebarList.sd = response.data[0].sd_selected;
          this.sidebarList.work_permit = response.data[0].work_permit_selected;
          this.sidebarList.lms = response.data[0].lms_selected;
          this.sidebarList.eptw_permit_selected = response.data[0].eptw_permit_selected;
        }
        if (window.localStorage.getItem('m_ind_token')) {
          if (window.localStorage.getItem('m_ind_type') == 'user' && this.sidebarList.issue == 1) {
            this.router.navigate(['incident-details']);
          }
          else if (window.localStorage.getItem('m_ind_type') == 'user' && this.sidebarList.issue2 == 1) {
            this.router.navigate(['Observation2Details']);
          }
          else if (this.sidebarList.eptw_permit_selected == 1) {
            this.router.navigate(['eptw-dashboard']);
          }
          else {
            this.router.navigate(['home']);
          }
        }

      }
    })
  }
}
